// HAFHTranslations.jsx
// en, hi, mr, gu, bn, ta, te, ka, ml, pu, as
export const HAFHTranslations = {
  en: {
    owner: "Owner",
    manager: "Manager",
    student: "Student",
    parent: "Parent",
    mess: "Mess",
    activities: "Activities",
    ranking: "Ranking",
    notifications: "Notifications",
    admin: "Admin",
    dashboard: "Dashboard",
    hpi: "Hostel Performance Index (HPI)",
    totalPoints: "Total Points",
    studentRanking: "Student Ranking",
    yourChild: "Your Child",
    institutionAdmin: "Institution Admin",
    quickAccess: "Quick Student Access",
    occupancy: "Occupancy",
    revenue: "Revenue",
    profitIndex: "Profit Index",
    activeHostels: "Active Hostels",
    occupied: "Occupied",
    vacant: "Vacant",
    hostels: "Hostels",
    hostelList: "Hostel List",
    students: "Students",
    studentDetails: "Student Details",
    messages: "Messages",
    messMenu: "Mess Menu",
    rankings: "Rankings",
    contacts: "Contacts",
    photos: "Photos",
    reply: "Reply",
    priority: "Priority",
    attendance: "Attendance",
    foodChoice: "Food Choice",
    warden: "Warden",
    seats: "Seats",
    rca: "Causal RCA",
    books: "Immersive Books",
    myBooks: "My Books",
    pocketMoney: "Pocket Money",
    ai: "AI",
    peer: "Peer",
    tasks: "Tasks",
    routine: "Routine",
    overview: "Overview",
    billing: "Billing",
    policy: "Policy",
    analytics: "Analytics",
    institution: "Institution",
    alerts: "Alerts",
    selfAttendance: "Self Attendance",
    compulsoryAttendance: "Comulsory Attendance",
    messAttendance: "Mess Attendance",
    activityAttendance: "Activity Attendance",
    menu: "Menu",
    transporter: "Transporter",
    schedule: "Schedule",
    roles: "Roles",
    features: "Features",
    audit: "Audit",
    settings: "Settings",
    signal: "AI Signals",
    emergency: "Emergency",
    pg: "PG",
    dormitory: "Dormitory",
    huma: "HUMA",
    outreach: "Outreach",
    contactPlatform: "Contact Tech Team",
    shareAttendance: "Share Attendance",
    share: "Share",
    downloadPDF: "Download",
    print: "Print",
    attendanceReports: "Attendance Report",
    dbDirector: "DigiDirector",
    applause: "Applause",
    transit: "Transit",
    hRoutine: "Hostel Routine",
    pSpace: "Personal Space",
    dosdont: "Do's & Don'ts",
    aiDashboard: "AI Dashboard",
    myDiary: "My Diary",
    trustee: "Trustee",
    onboarding: "Onboarding",
    coordinator: "Coordinator",
    records: "Records",
    hideattendcapt: "Hide Attendance Capture",
    showattendcapt: "Show Attendance Capture",
    main_gate: "Main Gate",
    room: "Room",
    indoor_activity:  "Indoor Activity",
    outdoor_activity:  "Outdoor Activity",
    offsite:  "Offsite",
    transit:  "Transit",
    hafhprofile: "Profile",
    hafhAbout: "About",
    hafhUpdates: "Updates",
    hafh: "Home Away From Home",
    subTitle: "A connected living ecosystem ensuring safety, discipline, visibility, and trust across every student journey at Home Away From Home.",

    applauseSub: "Give, receive, and track meaningful applause",
    profile: "Profile",
  },
  hi: {
    owner: "मालिक",
    manager: "प्रबंधक",
    student: "छात्र",
    parent: "अभिभावक",
    mess: "भोजनालय",
    activities: "गतिविधियाँ",
    ranking: "रैंकिंग",
    notifications: "सूचनाएँ",
    admin: "प्रशासक",
    dashboard: "डैशबोर्ड",
    hpi: "हॉस्टल परफॉर्मेंस इंडेक्स (HPI)",
    totalPoints: "कुल अंक",
    studentRanking: "छात्र रैंकिंग",
    yourChild: "आपका बच्चा",
    institutionAdmin: "संस्थान प्रशासक",
    quickAccess: "त्वरित छात्र पहुंच",
    occupancy: "अधिभोग",
    revenue: "राजस्व",
    profitIndex: "लाभ सूचकांक",
    activeHostels: "सक्रिय हॉस्टल",
    occupied: "भरा हुआ",
    vacant: "खाली",
    hostels: "हॉस्टल",
    hostelList: "हॉस्टल सूची",
    students: "छात्र",
    studentDetails: "छात्र विवरण",
    messages: "संदेश",
    messMenu: "भोजन मेनू",
    rankings: "रैंकिंग",
    contacts: "संपर्क",
    photos: "फोटो",
    reply: "जवाब",
    priority: "प्राथमिकता",
    attendance: "उपस्थिति",
    foodChoice: "भोजन विकल्प",
    warden: "वार्डन",
    seats: "सीटें",
    rca: "कारणात्मक मूल कारण विश्लेषण",
    books: "इमर्सिव पुस्तकें",
    myBooks: "मेरी पुस्तकें",
    pocketMoney: "जेब खर्च",
    ai: "एआई",
    peer: "सहकर्मी",
    tasks: "कार्य",
    routine: "दिनचर्या",
    overview: "अवलोकन",
    billing: "बिलिंग",
    policy: "नीति",
    analytics: "विश्लेषण",
    institution: "संस्थान",
    alerts: "अलर्ट",
    selfAttendance: "स्वयं उपस्थिति",
    compulsoryAttendance: "अनिवार्य उपस्थिति",
    messAttendance: "भोजनालय उपस्थिति",
    activityAttendance: "गतिविधि उपस्थिति",

    menu: "मेनू",
    transporter: "परिवहनकर्ता",
    schedule: "अनुसूची",
    roles: "भूमिकाएँ",
    features: "विशेषताएँ",
    audit: "ऑडिट",
    settings: "सेटिंग्स",
    signal: "एआई संकेत",
    emergency: "आपातकाल",
    pg: "पीजी",
    dormitory: "छात्रावास",
    huma: "HUMA",
    outreach: "आउटरीच",
    contactPlatform: "तकनीकी टीम से संपर्क",
    shareAttendance: "उपस्थिति साझा करें",
    share: "साझा करें",
    downloadPDF: "डाउनलोड",
    print: "प्रिंट",

    attendanceReports: "उपस्थिति रिपोर्ट",
    dbDirector: "डिजीडायरेक्टर",
    applause: "तालियाँ",
    transit: "ट्रांजिट",
    hRoutine: "हॉस्टल दिनचर्या",
    pSpace: "व्यक्तिगत स्थान",
    dosdont: "क्या करें और क्या न करें",
    aiDashboard: "एआई डैशबोर्ड",
    myDiary: "मेरी डायरी",
    trustee: "ट्रस्टी",
    onboarding: "ऑनबोर्डिंग",
    coordinator: "समन्वयक",
    records: "रिकॉर्ड्स",
    hideattendcapt: "उपस्थिति कैप्चर छुपाएं",
    showattendcapt: "उपस्थिति कैप्चर दिखाएं",
    main_gate: "मुख्य द्वार",
    room: "कमरा",
    indoor_activity: "इनडोर गतिविधि",
    outdoor_activity: "आउटडोर गतिविधि",
    offsite: "ऑफसाइट",
    hafhprofile: "प्रोफ़ाइल",
    hafhAbout: "हमारे बारे में",
    hafhUpdates: "अपडेट्स",
    hafh: "होम अवे फ्रॉम होम",
    subTitle: "एक जुड़ा हुआ लिविंग इकोसिस्टम जो हर छात्र की यात्रा में सुरक्षा, अनुशासन, पारदर्शिता और विश्वास सुनिश्चित करता है।",

    applauseSub: "अर्थपूर्ण सराहना दें, प्राप्त करें और ट्रैक करें",
  },
  mr: {
    owner: "मालक",
    manager: "व्यवस्थापक",
    student: "विद्यार्थी",
    parent: "पालक",
    mess: "भोजनालय",
    activities: "उपक्रम",
    ranking: "क्रमवारी",
    notifications: "सूचना",
    admin: "प्रशासक",
    dashboard: "डॅशबोर्ड",
    hpi: "हॉस्टेल परफॉर्मन्स इंडेक्स (HPI)",
    totalPoints: "एकूण गुण",
    studentRanking: "विद्यार्थी क्रमवारी",
    yourChild: "तुमचे मूल",
    institutionAdmin: "संस्था प्रशासक",
    quickAccess: "त्वरित विद्यार्थी प्रवेश",
    occupancy: "व्याप्ती",
    revenue: "महसूल",
    profitIndex: "नफा निर्देशांक",
    activeHostels: "सक्रिय हॉस्टेल",
    occupied: "भरलेले",
    vacant: "रिकामे",
    hostels: "हॉस्टेल्स",
    hostelList: "हॉस्टेल यादी",
    students: "विद्यार्थी",
    studentDetails: "विद्यार्थी तपशील",
    messages: "संदेश",
    messMenu: "भोजन मेनू",
    rankings: "क्रमवारी",
    contacts: "संपर्क",
    photos: "फोटो",
    reply: "उत्तर द्या",
    priority: "प्राधान्य",
    attendance: "हजेरी",
    foodChoice: "अन्न निवड",
    warden: "वॉर्डन",
    seats: "जागा",
    rca: "कारणात्मक मूळ कारण विश्लेषण",
    books: "इमर्सिव्ह पुस्तके",
    myBooks: "माझी पुस्तके",
    pocketMoney: "खिसे पैसे",
    ai: "एआय",
    peer: "समवयस्क",
    tasks: "कामे",
    routine: "दैनंदिन दिनचर्या",
    overview: "आढावा",
    billing: "बिलिंग",
    policy: "धोरण",
    analytics: "विश्लेषण",
    institution: "संस्था",
    alerts: "इशारे",
    selfAttendance: "स्वयं हजेरी",
    compulsoryAttendance: "अनिवार्य हजेरी",
    messAttendance: "भोजनालय हजेरी",
    activityAttendance: "उपक्रम हजेरी",

    menu: "मेनू",
    transporter: "वाहतूकदार",
    schedule: "वेळापत्रक",
    roles: "भूमिका",
    features: "वैशिष्ट्ये",
    audit: "ऑडिट",
    settings: "सेटिंग्ज",
    signal: "एआय संकेत",
    emergency: "आपत्काल",
    pg: "पीजी",
    dormitory: "वसतिगृह",
    huma: "HUMA",
    outreach: "आउटरीच",
    contactPlatform: "तांत्रिक टीमशी संपर्क",
    shareAttendance: "हजेरी शेअर करा",
    share: "शेअर करा",
    downloadPDF: "डाउनलोड",
    print: "प्रिंट",

    attendanceReports: "हजेरी अहवाल",
    dbDirector: "डिजीडायरेक्टर",
    applause: "टाळ्या",
    transit: "ट्रान्झिट",
    hRoutine: "हॉस्टेल दिनचर्या",
    pSpace: "वैयक्तिक जागा",
    dosdont: "करावे आणि करू नये",
    aiDashboard: "एआय डॅशबोर्ड",
    myDiary: "माझी डायरी",
    trustee: "विश्वस्त",
    onboarding: "ऑनबोर्डिंग",
    coordinator: "समन्वयक",
    records: "नोंदी",
    hideattendcapt: "हजेरी कॅप्चर लपवा",
    showattendcapt: "हजेरी कॅप्चर दाखवा",
    main_gate: "मुख्य प्रवेशद्वार",
    room: "खोली",
    indoor_activity: "इनडोअर उपक्रम",
    outdoor_activity: "आउटडोअर उपक्रम",
    offsite: "ऑफसाइट",
    hafhprofile: "प्रोफाइल",

    hafhAbout: "आमच्याबद्दल",
    hafhUpdates: "अपडेट्स",
    hafh: "होम अवे फ्रॉम होम",
    subTitle: "एक जोडलेले लिव्हिंग इकोसिस्टम जे प्रत्येक विद्यार्थ्याच्या प्रवासात सुरक्षा, शिस्त, पारदर्शकता आणि विश्वास सुनिश्चित करते.",

    applauseSub: "अर्थपूर्ण कौतुक द्या, स्वीकारा आणि ट्रॅक करा",
  },
  gu: {
    owner: "માલિક",
    manager: "વ્યવસ્થાપક",
    student: "વિદ્યાર્થી",
    parent: "વાલી",
    mess: "મેસ",
    activities: "પ્રવૃત્તિઓ",
    ranking: "ક્રમ",
    notifications: "સૂચનાઓ",
    admin: "પ્રશાસક",
    dashboard: "ડેશબોર્ડ",
    hpi: "હોસ્ટેલ પરફોર્મન્સ ઇન્ડેક્સ (HPI)",
    totalPoints: "કુલ ગુણ",
    studentRanking: "વિદ્યાર્થી ક્રમ",
    yourChild: "તમારું બાળક",
    institutionAdmin: "સંસ્થા પ્રશાસક",
    quickAccess: "ઝડપી વિદ્યાર્થી ઍક્સેસ",
    occupancy: "ઓક્યુપન્સી",
    revenue: "આવક",
    profitIndex: "નફા સૂચકાંક",
    activeHostels: "સક્રિય હોસ્ટેલ",
    occupied: "ભરાયેલ",
    vacant: "ખાલી",
    hostels: "હોસ્ટેલ્સ",
    hostelList: "હોસ્ટેલ યાદી",
    students: "વિદ્યાર્થીઓ",
    studentDetails: "વિદ્યાર્થી વિગતો",
    messages: "સંદેશાઓ",
    messMenu: "મેસ મેનુ",
    rankings: "ક્રમ",
    contacts: "સંપર્કો",
    photos: "ફોટા",
    reply: "જવાબ આપો",
    priority: "પ્રાથમિકતા",
    attendance: "હાજરી",
    foodChoice: "ભોજન પસંદગી",
    warden: "વોર્ડન",
    seats: "બેઠકો",
    rca: "કારણાત્મક મૂળ કારણ વિશ્લેષણ",
    books: "ઇમર્સિવ પુસ્તકો",
    myBooks: "મારા પુસ્તકો",
    pocketMoney: "ખિસ્સા પૈસા",
    ai: "એઆઈ",
    peer: "સહપાઠી",
    tasks: "કાર્યો",
    routine: "દૈનિક રૂટિન",
    overview: "ઝાંખી",
    billing: "બિલિંગ",
    policy: "નીતિ",
    analytics: "વિશ્લેષણ",
    institution: "સંસ્થા",
    alerts: "ચેતવણીઓ",
    selfAttendance: "સ્વ-હાજરી",
    compulsoryAttendance: "ફરજિયાત હાજરી",
    messAttendance: "મેસ હાજરી",
    activityAttendance: "પ્રવૃત્તિ હાજરી",

    menu: "મેનુ",
    transporter: "પરિવહનકાર",
    schedule: "સમયપત્રક",
    roles: "ભૂમિકાઓ",
    features: "વિશેષતાઓ",
    audit: "ઓડિટ",
    settings: "સેટિંગ્સ",
    signal: "એઆઈ સંકેતો",
    emergency: "આકસ્મિક",
    pg: "પીજી",
    dormitory: "હોસ્ટેલ",
    huma: "HUMA",
    outreach: "આઉટરીચ",
    contactPlatform: "ટેક ટીમનો સંપર્ક કરો",
    shareAttendance: "હાજરી શેર કરો",
    share: "શેર કરો",
    downloadPDF: "ડાઉનલોડ",
    print: "પ્રિન્ટ",

    attendanceReports: "હાજરી રિપોર્ટ",
    dbDirector: "ડિજીડિરેક્ટર",
    applause: "તાળીઓ",
    transit: "ટ્રાન્ઝિટ",
    hRoutine: "હોસ્ટેલ રૂટિન",
    pSpace: "વ્યક્તિગત જગ્યા",
    dosdont: "શું કરવું અને શું નહીં",
    aiDashboard: "એઆઈ ડેશબોર્ડ",
    myDiary: "મારી ડાયરી",
    trustee: "ટ્રસ્ટી",
    onboarding: "ઓનબોર્ડિંગ",
    coordinator: "સમન્વયક",
    records: "રેકોર્ડ્સ",
    hideattendcapt: "હાજરી કૅપ્ચર છુપાવો",
    showattendcapt: "હાજરી કૅપ્ચર બતાવો",
    main_gate: "મુખ્ય પ્રવેશદ્વાર",
    room: "રૂમ",
    indoor_activity: "ઇન્ડોર પ્રવૃત્તિ",
    outdoor_activity: "આઉટડોર પ્રવૃત્તિ",
    offsite: "ઓફસાઇટ",
    hafhprofile: "પ્રોફાઇલ",

    hafhAbout: "અમારા વિશે",
    hafhUpdates: "અપડેટ્સ",
    hafh: "હોમ અવે ફ્રોમ હોમ",
    subTitle: "એક જોડાયેલ લિવિંગ ઇકોસિસ્ટમ જે દરેક વિદ્યાર્થીની યાત્રામાં સુરક્ષા, શિસ્ત, પારદર્શિતા અને વિશ્વાસ સુનિશ્ચિત કરે છે.",

    applauseSub: "અર્થપૂર્ણ પ્રશંસા આપો, મેળવો અને ટ્રેક કરો",
  },
  bn: {
    owner: "মালিক",
    manager: "ম্যানেজার",
    student: "ছাত্র",
    parent: "অভিভাবক",
    mess: "মেস",
    activities: "কার্যক্রম",
    ranking: "র‍্যাঙ্কিং",
    notifications: "বিজ্ঞপ্তি",
    admin: "প্রশাসক",
    dashboard: "ড্যাশবোর্ড",
    hpi: "হোস্টেল পারফরম্যান্স ইনডেক্স (HPI)",
    totalPoints: "মোট পয়েন্ট",
    studentRanking: "ছাত্র র‍্যাঙ্কিং",
    yourChild: "আপনার সন্তান",
    institutionAdmin: "প্রতিষ্ঠান প্রশাসক",
    quickAccess: "দ্রুত ছাত্র অ্যাক্সেস",
    occupancy: "অধিভোগ",
    revenue: "রাজস্ব",
    profitIndex: "লাভ সূচক",
    activeHostels: "সক্রিয় হোস্টেল",
    occupied: "পূর্ণ",
    vacant: "খালি",
    hostels: "হোস্টেল",
    hostelList: "হোস্টেল তালিকা",
    students: "ছাত্ররা",
    studentDetails: "ছাত্র বিবরণ",
    messages: "বার্তা",
    messMenu: "মেস মেনু",
    rankings: "র‍্যাঙ্কিং",
    contacts: "যোগাযোগ",
    photos: "ছবি",
    reply: "উত্তর দিন",
    priority: "অগ্রাধিকার",
    attendance: "উপস্থিতি",
    foodChoice: "খাবারের পছন্দ",
    warden: "ওয়ার্ডেন",
    seats: "আসন",
    rca: "কারণমূলক মূল কারণ বিশ্লেষণ",
    books: "ইমার্সিভ বই",
    myBooks: "আমার বই",
    pocketMoney: "পকেট মানি",
    ai: "এআই",
    peer: "সহপাঠী",
    tasks: "কাজ",
    routine: "রুটিন",
    overview: "সংক্ষিপ্ত বিবরণ",
    billing: "বিলিং",
    policy: "নীতি",
    analytics: "বিশ্লেষণ",
    institution: "প্রতিষ্ঠান",
    alerts: "সতর্কতা",
    selfAttendance: "স্ব-উপস্থিতি",
    compulsoryAttendance: "বাধ্যতামূলক উপস্থিতি",
    messAttendance: "মেস উপস্থিতি",
    activityAttendance: "কার্যক্রম উপস্থিতি",

    menu: "মেনু",
    transporter: "পরিবহনকারী",
    schedule: "সময়সূচি",
    roles: "ভূমিকা",
    features: "বৈশিষ্ট্য",
    audit: "অডিট",
    settings: "সেটিংস",
    signal: "এআই সংকেত",
    emergency: "জরুরি",
    pg: "পিজি",
    dormitory: "ডরমিটরি",
    huma: "HUMA",
    outreach: "আউটরিচ",
    contactPlatform: "টেক টিমের সাথে যোগাযোগ করুন",
    shareAttendance: "উপস্থিতি শেয়ার করুন",
    share: "শেয়ার",
    downloadPDF: "ডাউনলোড",
    print: "প্রিন্ট",

    attendanceReports: "উপস্থিতি রিপোর্ট",
    dbDirector: "ডিজিডিরেক্টর",
    applause: "তালি",
    transit: "ট্রানজিট",
    hRoutine: "হোস্টেল রুটিন",
    pSpace: "ব্যক্তিগত স্থান",
    dosdont: "করণীয় ও বর্জনীয়",
    aiDashboard: "এআই ড্যাশবোর্ড",
    myDiary: "আমার ডায়েরি",
    trustee: "ট্রাস্টি",
    onboarding: "অনবোর্ডিং",
    coordinator: "সমন্বয়কারী",
    records: "রেকর্ড",
    hideattendcapt: "উপস্থিতি ক্যাপচার লুকান",
    showattendcapt: "উপস্থিতি ক্যাপচার দেখান",
    main_gate: "প্রধান গেট",
    room: "ঘর",
    indoor_activity: "ইনডোর কার্যক্রম",
    outdoor_activity: "আউটডোর কার্যক্রম",
    offsite: "অফসাইট",
    hafhprofile: "প্রোফাইল",

    hafhAbout: "আমাদের সম্পর্কে",
    hafhUpdates: "আপডেটস",
    hafh: "হোম অ্যাওয়ে ফ্রম হোম",
    subTitle: "একটি সংযুক্ত লিভিং ইকোসিস্টেম যা প্রতিটি শিক্ষার্থীর যাত্রায় নিরাপত্তা, শৃঙ্খলা, স্বচ্ছতা এবং বিশ্বাস নিশ্চিত করে।",

    applauseSub: "Give, receive, and track meaningful applause",
  },
  ta: {
    owner: "உரிமையாளர்",
    manager: "மேலாளர்",
    student: "மாணவர்",
    parent: "பெற்றோர்",
    mess: "மெஸ்",
    activities: "செயல்பாடுகள்",
    ranking: "தரவரிசை",
    notifications: "அறிவிப்புகள்",
    admin: "நிர்வாகி",
    dashboard: "டாஷ்போர்டு",
    hpi: "ஹாஸ்டல் செயல்திறன் குறியீடு (HPI)",
    totalPoints: "மொத்த புள்ளிகள்",
    studentRanking: "மாணவர் தரவரிசை",
    yourChild: "உங்கள் குழந்தை",
    institutionAdmin: "நிறுவன நிர்வாகி",
    quickAccess: "விரைவு மாணவர் அணுகல்",
    occupancy: "நிறைவு நிலை",
    revenue: "வருவாய்",
    profitIndex: "லாப குறியீடு",
    activeHostels: "செயலில் உள்ள ஹாஸ்டல்கள்",
    occupied: "நிறைந்தது",
    vacant: "காலி",
    hostels: "ஹாஸ்டல்கள்",
    hostelList: "ஹாஸ்டல் பட்டியல்",
    students: "மாணவர்கள்",
    studentDetails: "மாணவர் விவரங்கள்",
    messages: "செய்திகள்",
    messMenu: "மெஸ் மெனு",
    rankings: "தரவரிசை",
    contacts: "தொடர்புகள்",
    photos: "புகைப்படங்கள்",
    reply: "பதில்",
    priority: "முன்னுரிமை",
    attendance: "வருகை",
    foodChoice: "உணவு தேர்வு",
    warden: "வார்டன்",
    seats: "இடங்கள்",
    rca: "காரண அடிப்படை பகுப்பாய்வு",
    books: "மூழ்கும் புத்தகங்கள்",
    myBooks: "என் புத்தகங்கள்",
    pocketMoney: "பாக்கெட் பணம்",
    ai: "ஏஐ",
    peer: "சக மாணவர்",
    tasks: "பணிகள்",
    routine: "அட்டவணை",
    overview: "மேலோட்டம்",
    billing: "பில்",
    policy: "கொள்கை",
    analytics: "பகுப்பாய்வு",
    institution: "நிறுவனம்",
    alerts: "எச்சரிக்கைகள்",
    selfAttendance: "சுய வருகை",
    compulsoryAttendance: "கட்டாய வருகை",
    messAttendance: "மெஸ் வருகை",
    activityAttendance: "செயல்பாட்டு வருகை",

    menu: "மெனு",
    transporter: "போக்குவரத்தாளர்",
    schedule: "அட்டவணை",
    roles: "பாத்திரங்கள்",
    features: "அம்சங்கள்",
    audit: "தணிக்கை",
    settings: "அமைப்புகள்",
    signal: "ஏஐ சிக்னல்கள்",
    emergency: "அவசரம்",
    pg: "பிஜி",
    dormitory: "தங்கும் விடுதி",
    huma: "HUMA",
    outreach: "வெளியோட்டம்",
    contactPlatform: "டெக் குழுவை தொடர்பு கொள்ளவும்",
    shareAttendance: "வருகையை பகிர்",
    share: "பகிர்",
    downloadPDF: "பதிவிறக்கு",
    print: "அச்சிடு",

    attendanceReports: "வருகை அறிக்கை",
    dbDirector: "டிஜிடைரக்டர்",
    applause: "கரகோஷம்",
    transit: "போக்குவரத்து",
    hRoutine: "ஹாஸ்டல் தினசரி அட்டவணை",
    pSpace: "தனிப்பட்ட இடம்",
    dosdont: "செய்யவேண்டியது & செய்யக்கூடாதது",
    aiDashboard: "ஏஐ டாஷ்போர்டு",
    myDiary: "என் டைரி",
    trustee: "நம்பிக்கைத் தலைவர்",
    onboarding: "ஆன்போர்டிங்",
    coordinator: "ஒருங்கிணைப்பாளர்",
    records: "பதிவுகள்",
    hideattendcapt: "வருகை பதிவை மறை",
    showattendcapt: "வருகை பதிவை காட்டு",
    main_gate: "முக்கிய நுழைவாயில்",
    room: "அறை",
    indoor_activity: "உள்ளக செயல்பாடு",
    outdoor_activity: "வெளிப்புற செயல்பாடு",
    offsite: "வெளி இடம்",
    hafhprofile: "சுயவிவரம்",

    hafhAbout: "எங்களைப் பற்றி",
    hafhUpdates: "புதுப்பிப்புகள்",
    hafh: "ஹோம் அவே ஃப்ரம் ஹோம்",
    subTitle: "ஒவ்வொரு மாணவரின் பயணத்திலும் பாதுகாப்பு, ஒழுக்கம், வெளிப்படைத் தன்மை மற்றும் நம்பிக்கையை உறுதி செய்யும் ஒரு இணைந்த வாழ்வு சூழல்.",

    applauseSub: "Give, receive, and track meaningful applause",
  },
  te: {
    owner: "యజమాని",
    manager: "మేనేజర్",
    student: "విద్యార్థి",
    parent: "తల్లిదండ్రులు",
    mess: "మెస్",
    activities: "కార్యకలాపాలు",
    ranking: "ర్యాంకింగ్",
    notifications: "నోటిఫికేషన్లు",
    admin: "నిర్వాహకుడు",
    dashboard: "డాష్‌బోర్డ్",
    hpi: "హాస్టల్ పనితీరు సూచిక (HPI)",
    totalPoints: "మొత్తం పాయింట్లు",
    studentRanking: "విద్యార్థి ర్యాంకింగ్",
    yourChild: "మీ బిడ్డ",
    institutionAdmin: "సంస్థ నిర్వాహకుడు",
    quickAccess: "త్వరిత విద్యార్థి యాక్సెస్",
    occupancy: "ఆక్యుపెన్సీ",
    revenue: "ఆదాయం",
    profitIndex: "లాభ సూచిక",
    activeHostels: "సక్రియ హాస్టల్స్",
    occupied: "పూర్తిగా నిండినవి",
    vacant: "ఖాళీగా ఉన్నాయి",
    hostels: "హాస్టల్స్",
    hostelList: "హాస్టల్ జాబితా",
    students: "విద్యార్థులు",
    studentDetails: "విద్యార్థి వివరాలు",
    messages: "సందేశాలు",
    messMenu: "మెస్ మెనూ",
    rankings: "ర్యాంకింగ్",
    contacts: "సంప్రదింపులు",
    photos: "ఫోటోలు",
    reply: "ప్రత్యుత్తరం ఇవ్వండి",
    priority: "ప్రాధాన్యత",
    attendance: "హాజరు",
    foodChoice: "ఆహార ఎంపిక",
    warden: "వార్డెన్",
    seats: "సీట్లు",
    rca: "కారణాత్మక మూల కారణ విశ్లేషణ",
    books: "ఇమర్సివ్ పుస్తకాలు",
    myBooks: "నా పుస్తకాలు",
    pocketMoney: "పాకెట్ మనీ",
    ai: "ఏఐ",
    peer: "సహచరుడు",
    tasks: "పనులు",
    routine: "రోజువారీ రొటీన్",
    overview: "అవలోకనం",
    billing: "బిల్లింగ్",
    policy: "విధానం",
    analytics: "విశ్లేషణలు",
    institution: "సంస్థ",
    alerts: "అలర్ట్స్",
    selfAttendance: "స్వీయ హాజరు",
    compulsoryAttendance: "తప్పనిసరి హాజరు",
    messAttendance: "మెస్ హాజరు",
    activityAttendance: "కార్యకలాప హాజరు",

    menu: "మెను",
    transporter: "రవాణాదారు",
    schedule: "షెడ్యూల్",
    roles: "పాత్రలు",
    features: "ఫీచర్లు",
    audit: "ఆడిట్",
    settings: "సెట్టింగ్స్",
    signal: "ఏఐ సంకేతాలు",
    emergency: "అత్యవసరం",
    pg: "పీజీ",
    dormitory: "డార్మిటరీ",
    huma: "HUMA",
    outreach: "అవుట్‌రీచ్",
    contactPlatform: "టెక్ టీమ్‌ను సంప్రదించండి",
    shareAttendance: "హాజరు పంచుకోండి",
    share: "షేర్",
    downloadPDF: "డౌన్‌లోడ్",
    print: "ప్రింట్",

    attendanceReports: "హాజరు నివేదిక",
    dbDirector: "డిజీడైరెక్టర్",
    applause: "చప్పట్లు",
    transit: "ట్రాన్సిట్",
    hRoutine: "హాస్టల్ రొటీన్",
    pSpace: "వ్యక్తిగత స్థలం",
    dosdont: "చేయవలసినవి & చేయకూడనివి",
    aiDashboard: "ఏఐ డాష్‌బోర్డ్",
    myDiary: "నా డైరీ",
    trustee: "ట్రస్టీ",
    onboarding: "ఆన్‌బోర్డింగ్",
    coordinator: "కోఆర్డినేటర్",
    records: "రికార్డులు",
    hideattendcapt: "హాజరు క్యాప్చర్ దాచు",
    showattendcapt: "హాజరు క్యాప్చర్ చూపించు",
    main_gate: "ముఖ్య గేటు",
    room: "గది",
    indoor_activity: "ఇండోర్ కార్యకలాపం",
    outdoor_activity: "అవుట్‌డోర్ కార్యకలాపం",
    offsite: "ఆఫ్‌సైట్",
    hafhprofile: "ప్రొఫైల్",

    hafhAbout: "మా గురించి",
    hafhUpdates: "అప్డేట్లు",
    hafh: "హోమ్ అవే ఫ్రం హోమ్",
    subTitle: "ప్రతి విద్యార్థి ప్రయాణంలో భద్రత, క్రమశిక్షణ, పారదర్శకత మరియు నమ్మకాన్ని నిర్ధారించే ఒక అనుసంధానిత లివింగ్ ఎకోసిస్టమ్.",

    applauseSub: "Give, receive, and track meaningful applause",
  },
  kn: {
    owner: "ಮಾಲೀಕ",
    manager: "ವ್ಯವಸ್ಥಾಪಕ",
    student: "ವಿದ್ಯಾರ್ಥಿ",
    parent: "ಪೋಷಕರು",
    mess: "ಮೆಸ್",
    activities: "ಚಟುವಟಿಕೆಗಳು",
    ranking: "ರ‍್ಯಾಂಕಿಂಗ್",
    notifications: "ಅಧಿಸೂಚನೆಗಳು",
    admin: "ನಿರ್ವಹಣಾಧಿಕಾರಿ",
    dashboard: "ಡ್ಯಾಶ್‌ಬೋರ್ಡ್",
    hpi: "ಹಾಸ್ಟೆಲ್ ಕಾರ್ಯಕ್ಷಮತೆ ಸೂಚ್ಯಂಕ (HPI)",
    totalPoints: "ಒಟ್ಟು ಅಂಕಗಳು",
    studentRanking: "ವಿದ್ಯಾರ್ಥಿ ರ‍್ಯಾಂಕಿಂಗ್",
    yourChild: "ನಿಮ್ಮ ಮಗು",
    institutionAdmin: "ಸಂಸ್ಥೆಯ ನಿರ್ವಹಣಾಧಿಕಾರಿ",
    quickAccess: "ತ್ವರಿತ ವಿದ್ಯಾರ್ಥಿ ಪ್ರವೇಶ",
    occupancy: "ಆಕ್ರಮಣ",
    revenue: "ಆದಾಯ",
    profitIndex: "ಲಾಭ ಸೂಚ್ಯಂಕ",
    activeHostels: "ಸಕ್ರಿಯ ಹಾಸ್ಟೆಲ್‌ಗಳು",
    occupied: "ಭರ್ತಿ ಆಗಿದೆ",
    vacant: "ಖಾಲಿ",
    hostels: "ಹಾಸ್ಟೆಲ್‌ಗಳು",
    hostelList: "ಹಾಸ್ಟೆಲ್ ಪಟ್ಟಿ",
    students: "ವಿದ್ಯಾರ್ಥಿಗಳು",
    studentDetails: "ವಿದ್ಯಾರ್ಥಿ ವಿವರಗಳು",
    messages: "ಸಂದೇಶಗಳು",
    messMenu: "ಮೆಸ್ ಮೆನು",
    rankings: "ರ‍್ಯಾಂಕಿಂಗ್",
    contacts: "ಸಂಪರ್ಕಗಳು",
    photos: "ಫೋಟೋಗಳು",
    reply: "ಪ್ರತ್ಯುತ್ತರ",
    priority: "ಪ್ರಾಥಮಿಕತೆ",
    attendance: "ಹಾಜರಾತಿ",
    foodChoice: "ಆಹಾರ ಆಯ್ಕೆ",
    warden: "ವಾರ್ಡನ್",
    seats: "ಆಸನಗಳು",
    rca: "ಕಾರಣಾತ್ಮಕ ಮೂಲ ಕಾರಣ ವಿಶ್ಲೇಷಣೆ",
    books: "ಇಮರ್ಸಿವ್ ಪುಸ್ತಕಗಳು",
    myBooks: "ನನ್ನ ಪುಸ್ತಕಗಳು",
    pocketMoney: "ಪಾಕೆಟ್ ಹಣ",
    ai: "ಎಐ",
    peer: "ಸಹಪಾಠಿ",
    tasks: "ಕಾರ್ಯಗಳು",
    routine: "ದಿನಚರಿ",
    overview: "ಅವಲೋಕನ",
    billing: "ಬಿಲ್ಲಿಂಗ್",
    policy: "ನೀತಿ",
    analytics: "ವಿಶ್ಲೇಷಣೆ",
    institution: "ಸಂಸ್ಥೆ",
    alerts: "ಎಚ್ಚರಿಕೆಗಳು",
    selfAttendance: "ಸ್ವಯಂ ಹಾಜರಾತಿ",
    compulsoryAttendance: "ಕಡ್ಡಾಯ ಹಾಜರಾತಿ",
    messAttendance: "ಮೆಸ್ ಹಾಜರಾತಿ",
    activityAttendance: "ಚಟುವಟಿಕೆ ಹಾಜರಾತಿ",

    menu: "ಮೆನು",
    transporter: "ಸಾರಿಗೆಗಾರ",
    schedule: "ವೇಳಾಪಟ್ಟಿ",
    roles: "ಪಾತ್ರಗಳು",
    features: "ವೈಶಿಷ್ಟ್ಯಗಳು",
    audit: "ಆಡಿಟ್",
    settings: "ಸೆಟ್ಟಿಂಗ್‌ಗಳು",
    signal: "ಎಐ ಸಿಗ್ನಲ್‌ಗಳು",
    emergency: "ತುರ್ತು",
    pg: "ಪಿಜಿ",
    dormitory: "ನಿವಾಸಗೃಹ",
    huma: "HUMA",
    outreach: "ಔಟ್ರೀಚ್",
    contactPlatform: "ಟೆಕ್ ತಂಡವನ್ನು ಸಂಪರ್ಕಿಸಿ",
    shareAttendance: "ಹಾಜರಾತಿ ಹಂಚಿಕೊಳ್ಳಿ",
    share: "ಹಂಚಿಕೊಳ್ಳಿ",
    downloadPDF: "ಡೌನ್‌ಲೋಡ್",
    print: "ಮುದ್ರಿಸು",

    attendanceReports: "ಹಾಜರಾತಿ ವರದಿ",
    dbDirector: "ಡಿಜಿಡೈರೆಕ್ಟರ್",
    applause: "ಚಪ್ಪಾಳೆ",
    transit: "ಸಂಚಾರ",
    hRoutine: "ಹಾಸ್ಟೆಲ್ ದಿನಚರಿ",
    pSpace: "ವೈಯಕ್ತಿಕ ಸ್ಥಳ",
    dosdont: "ಮಾಡಬೇಕಾದ ಮತ್ತು ಮಾಡಬಾರದವುಗಳು",
    aiDashboard: "ಎಐ ಡ್ಯಾಶ್‌ಬೋರ್ಡ್",
    myDiary: "ನನ್ನ ದಿನಚರಿ",
    trustee: "ಟ್ರಸ್ಟಿ",
    onboarding: "ಆನ್‌ಬೋರ್ಡಿಂಗ್",
    coordinator: "ಸಮನ್ವಯಕ",
    records: "ದಾಖಲೆಗಳು",
    hideattendcapt: "ಹಾಜರಾತಿ ಕ್ಯಾಪ್ಚರ್ ಮರೆಮಾಡಿ",
    showattendcapt: "ಹಾಜರಾತಿ ಕ್ಯಾಪ್ಚರ್ ತೋರಿಸಿ",
    main_gate: "ಮುಖ್ಯ ದ್ವಾರ",
    room: "ಕೊಠಡಿ",
    indoor_activity: "ಒಳಾಂಗಣ ಚಟುವಟಿಕೆ",
    outdoor_activity: "ಹೊರಾಂಗಣ ಚಟುವಟಿಕೆ",
    offsite: "ಸ್ಥಳಾಂತರ",
    hafhprofile: "ಪ್ರೊಫೈಲ್",

    hafhAbout: "ನಮ್ಮ ಬಗ್ಗೆ",
    hafhUpdates: "ಅಪ್ಡೇಟ್ಗಳು",
    hafh: "ಹೋಮ್ ಅವೇ ಫ್ರಮ್ ಹೋಮ್",
    subTitle: "ಪ್ರತಿ ವಿದ್ಯಾರ್ಥಿಯ ಪ್ರಯಾಣದಲ್ಲಿ ಭದ್ರತೆ, ಶಿಸ್ತು, ಪಾರದರ್ಶಕತೆ ಮತ್ತು ನಂಬಿಕೆಯನ್ನು ಖಚಿತಪಡಿಸುವ ಒಂದು ಸಂಪರ್ಕಿತ ಲಿವಿಂಗ್ ಇಕೋಸಿಸ್ಟಮ್.",

    applauseSub: "Give, receive, and track meaningful applause",
  },
  ml: {
    owner: "ഉടമ",
    manager: "മാനേജർ",
    student: "വിദ്യാർത്ഥി",
    parent: "മാതാപിതാക്കൾ",
    mess: "മെസ്",
    activities: "പ്രവർത്തനങ്ങൾ",
    ranking: "റാങ്കിംഗ്",
    notifications: "അറിയിപ്പുകൾ",
    admin: "അഡ്മിൻ",
    dashboard: "ഡാഷ്‌ബോർഡ്",
    hpi: "ഹോസ്റ്റൽ പ്രകടന സൂചിക (HPI)",
    totalPoints: "ആകെ പോയിന്റുകൾ",
    studentRanking: "വിദ്യാർത്ഥി റാങ്കിംഗ്",
    yourChild: "നിങ്ങളുടെ കുട്ടി",
    institutionAdmin: "സ്ഥാപന അഡ്മിൻ",
    quickAccess: "വേഗത്തിലുള്ള വിദ്യാർത്ഥി പ്രവേശനം",
    occupancy: "അധിവസനം",
    revenue: "വരുമാനം",
    profitIndex: "ലാഭ സൂചിക",
    activeHostels: "സജീവ ഹോസ്റ്റലുകൾ",
    occupied: "നിറഞ്ഞത്",
    vacant: "ശൂന്യം",
    hostels: "ഹോസ്റ്റലുകൾ",
    hostelList: "ഹോസ്റ്റൽ പട്ടിക",
    students: "വിദ്യാർത്ഥികൾ",
    studentDetails: "വിദ്യാർത്ഥി വിശദാംശങ്ങൾ",
    messages: "സന്ദേശങ്ങൾ",
    messMenu: "മെസ് മെനു",
    rankings: "റാങ്കിംഗ്",
    contacts: "ബന്ധങ്ങൾ",
    photos: "ഫോട്ടോകൾ",
    reply: "മറുപടി",
    priority: "മുൻഗണന",
    attendance: "ഹാജർ",
    foodChoice: "ഭക്ഷണ തിരഞ്ഞെടുപ്പ്",
    warden: "വാർഡൻ",
    seats: "സീറ്റുകൾ",
    rca: "കാരണം അടിസ്ഥാന വിശകലനം",
    books: "ഇമ്മേഴ്സീവ് പുസ്തകങ്ങൾ",
    myBooks: "എന്റെ പുസ്തകങ്ങൾ",
    pocketMoney: "പോക്കറ്റ് മണി",
    ai: "എഐ",
    peer: "സഹപാഠി",
    tasks: "ചുമതലകൾ",
    routine: "ദിനചര്യ",
    overview: "അവലോകനം",
    billing: "ബില്ലിംഗ്",
    policy: "നയം",
    analytics: "വിശകലനം",
    institution: "സ്ഥാപനം",
    alerts: "അലർട്ടുകൾ",
    selfAttendance: "സ്വയം ഹാജർ",
    compulsoryAttendance: "നിർബന്ധിത ഹാജർ",
    messAttendance: "മെസ് ഹാജർ",
    activityAttendance: "പ്രവർത്തന ഹാജർ",

    menu: "മെനു",
    transporter: "ഗതാഗതക്കാരൻ",
    schedule: "ക്രമീകരണം",
    roles: "പങ്കുകൾ",
    features: "സവിശേഷതകൾ",
    audit: "ഓഡിറ്റ്",
    settings: "ക്രമീകരണങ്ങൾ",
    signal: "എഐ സിഗ്നലുകൾ",
    emergency: "അടിയന്തരാവസ്ഥ",
    pg: "പി.ജി",
    dormitory: "ഡോർമിറ്ററി",
    huma: "HUMA",
    outreach: "ഔട്ട്‌റീച്ച്",
    contactPlatform: "ടെക് ടീമിനെ ബന്ധപ്പെടുക",
    shareAttendance: "ഹാജർ പങ്കിടുക",
    share: "പങ്കിടുക",
    downloadPDF: "ഡൗൺലോഡ്",
    print: "പ്രിന്റ്",

    attendanceReports: "ഹാജർ റിപ്പോർട്ട്",
    dbDirector: "ഡിജിഡയറക്ടർ",
    applause: "കരഘോഷം",
    transit: "ട്രാൻസിറ്റ്",
    hRoutine: "ഹോസ്റ്റൽ ദിനചര്യ",
    pSpace: "വ്യക്തിഗത സ്ഥലം",
    dosdont: "ചെയ്യേണ്ടതും ചെയ്യരുതാത്തതും",
    aiDashboard: "എഐ ഡാഷ്‌ബോർഡ്",
    myDiary: "എന്റെ ഡയറി",
    trustee: "ട്രസ്റ്റി",
    onboarding: "ഓൺബോർഡിംഗ്",
    coordinator: "കോഓർഡിനേറ്റർ",
    records: "റെക്കോർഡുകൾ",
    hideattendcapt: "ഹാജർ ക്യാപ്ചർ മറയ്ക്കുക",
    showattendcapt: "ഹാജർ ക്യാപ്ചർ കാണിക്കുക",
    main_gate: "പ്രധാന ഗേറ്റ്",
    room: "മുറി",
    indoor_activity: "ഇൻഡോർ പ്രവർത്തനം",
    outdoor_activity: "ഔട്ട്ഡോർ പ്രവർത്തനം",
    offsite: "ഓഫ്‌സൈറ്റ്",
    hafhprofile: "പ്രൊഫൈൽ",

    hafhAbout: "ഞങ്ങളേക്കുറിച്ച്",
    hafhUpdates: "അപ്ഡേറ്റുകൾ",
    hafh: "ഹോം അവേ ഫ്രം ഹോം",
    subTitle: "ഓരോ വിദ്യാർത്ഥിയുടെയും യാത്രയിൽ സുരക്ഷ, ശാസനം, വ്യക്തത, വിശ്വാസം എന്നിവ ഉറപ്പാക്കുന്ന ഒരു ബന്ധിതമായ ലിവിംഗ് ഇക്കോസിസ്റ്റം.",

    applauseSub: "Give, receive, and track meaningful applause",
  },
  pa: {
    owner: "ਮਾਲਕ",
    manager: "ਪ੍ਰਬੰਧਕ",
    student: "ਵਿਦਿਆਰਥੀ",
    parent: "ਮਾਤਾ-ਪਿਤਾ",
    mess: "ਮੇਸ",
    activities: "ਗਤੀਵਿਧੀਆਂ",
    ranking: "ਰੈਂਕਿੰਗ",
    notifications: "ਸੂਚਨਾਵਾਂ",
    admin: "ਪ੍ਰਸ਼ਾਸਕ",
    dashboard: "ਡੈਸ਼ਬੋਰਡ",
    hpi: "ਹੋਸਟਲ ਪ੍ਰਦਰਸ਼ਨ ਸੂਚਕਾਂਕ (HPI)",
    totalPoints: "ਕੁੱਲ ਅੰਕ",
    studentRanking: "ਵਿਦਿਆਰਥੀ ਰੈਂਕਿੰਗ",
    yourChild: "ਤੁਹਾਡਾ ਬੱਚਾ",
    institutionAdmin: "ਸੰਸਥਾ ਪ੍ਰਸ਼ਾਸਕ",
    quickAccess: "ਤੁਰੰਤ ਵਿਦਿਆਰਥੀ ਪਹੁੰਚ",
    occupancy: "ਕਬਜ਼ਾ",
    revenue: "ਆਮਦਨ",
    profitIndex: "ਮੁਨਾਫਾ ਸੂਚਕਾਂਕ",
    activeHostels: "ਸਰਗਰਮ ਹੋਸਟਲ",
    occupied: "ਭਰੇ ਹੋਏ",
    vacant: "ਖਾਲੀ",
    hostels: "ਹੋਸਟਲ",
    hostelList: "ਹੋਸਟਲ ਸੂਚੀ",
    students: "ਵਿਦਿਆਰਥੀ",
    studentDetails: "ਵਿਦਿਆਰਥੀ ਵੇਰਵੇ",
    messages: "ਸੁਨੇਹੇ",
    messMenu: "ਮੇਸ ਮੀਨੂ",
    rankings: "ਰੈਂਕਿੰਗ",
    contacts: "ਸੰਪਰਕ",
    photos: "ਫੋਟੋਆਂ",
    reply: "ਜਵਾਬ ਦਿਓ",
    priority: "ਤਰਜੀਹ",
    attendance: "ਹਾਜ਼ਰੀ",
    foodChoice: "ਭੋਜਨ ਚੋਣ",
    warden: "ਵਾਰਡਨ",
    seats: "ਸੀਟਾਂ",
    rca: "ਕਾਰਣਾਤਮਕ ਮੂਲ ਕਾਰਨ ਵਿਸ਼ਲੇਸ਼ਣ",
    books: "ਇਮਰਸਿਵ ਕਿਤਾਬਾਂ",
    myBooks: "ਮੇਰੀਆਂ ਕਿਤਾਬਾਂ",
    pocketMoney: "ਜੇਬ ਖਰਚ",
    ai: "ਏਆਈ",
    peer: "ਸਾਥੀ",
    tasks: "ਕੰਮ",
    routine: "ਰੁਟੀਨ",
    overview: "ਸੰਖੇਪ",
    billing: "ਬਿਲਿੰਗ",
    policy: "ਨੀਤੀ",
    analytics: "ਵਿਸ਼ਲੇਸ਼ਣ",
    institution: "ਸੰਸਥਾ",
    alerts: "ਚੇਤਾਵਨੀਆਂ",
    selfAttendance: "ਸਵੈ ਹਾਜ਼ਰੀ",
    compulsoryAttendance: "ਲਾਜ਼ਮੀ ਹਾਜ਼ਰੀ",
    messAttendance: "ਮੇਸ ਹਾਜ਼ਰੀ",
    activityAttendance: "ਗਤੀਵਿਧੀ ਹਾਜ਼ਰੀ",

    menu: "ਮੇਨੂ",
    transporter: "ਪਰਿਵਾਹਕ",
    schedule: "ਸਮਾਂ-ਸੂਚੀ",
    roles: "ਭੂਮਿਕਾਵਾਂ",
    features: "ਵਿਸ਼ੇਸ਼ਤਾਵਾਂ",
    audit: "ਆਡਿਟ",
    settings: "ਸੈਟਿੰਗਾਂ",
    signal: "ਏਆਈ ਸੰਕੇਤ",
    emergency: "ਐਮਰਜੈਂਸੀ",
    pg: "ਪੀਜੀ",
    dormitory: "ਡਾਰਮਿਟਰੀ",
    huma: "HUMA",
    outreach: "ਆਉਟਰੀਚ",
    contactPlatform: "ਟੈਕ ਟੀਮ ਨਾਲ ਸੰਪਰਕ ਕਰੋ",
    shareAttendance: "ਹਾਜ਼ਰੀ ਸਾਂਝੀ ਕਰੋ",
    share: "ਸਾਂਝਾ ਕਰੋ",
    downloadPDF: "ਡਾਊਨਲੋਡ",
    print: "ਪ੍ਰਿੰਟ",

    attendanceReports: "ਹਾਜ਼ਰੀ ਰਿਪੋਰਟ",
    dbDirector: "ਡਿਜੀਡਾਇਰੈਕਟਰ",
    applause: "ਤਾਲੀਆਂ",
    transit: "ਟਰਾਂਜ਼ਿਟ",
    hRoutine: "ਹੋਸਟਲ ਰੁਟੀਨ",
    pSpace: "ਨਿੱਜੀ ਜਗ੍ਹਾ",
    dosdont: "ਕੀ ਕਰਨਾ ਹੈ ਤੇ ਕੀ ਨਹੀਂ",
    aiDashboard: "ਏਆਈ ਡੈਸ਼ਬੋਰਡ",
    myDiary: "ਮੇਰੀ ਡਾਇਰੀ",
    trustee: "ਟ੍ਰਸਟੀ",
    onboarding: "ਓਨਬੋਰਡਿੰਗ",
    coordinator: "ਕੋਆਰਡੀਨੇਟਰ",
    records: "ਰਿਕਾਰਡ",
    hideattendcapt: "ਹਾਜ਼ਰੀ ਕੈਪਚਰ ਛੁਪਾਓ",
    showattendcapt: "ਹਾਜ਼ਰੀ ਕੈਪਚਰ ਦਿਖਾਓ",
    main_gate: "ਮੁੱਖ ਗੇਟ",
    room: "ਕਮਰਾ",
    indoor_activity: "ਅੰਦਰੂਨੀ ਗਤੀਵਿਧੀ",
    outdoor_activity: "ਬਾਹਰੀ ਗਤੀਵਿਧੀ",
    offsite: "ਆਫਸਾਈਟ",
    hafhprofile: "ਪ੍ਰੋਫਾਈਲ",

    hafhAbout: "ਸਾਡੇ ਬਾਰੇ",
    hafhUpdates: "ਅਪਡੇਟਸ",
    hafh: "ਹੋਮ ਅਵੇ ਫ੍ਰਮ ਹੋਮ",
    subTitle: "ਹਰ ਵਿਦਿਆਰਥੀ ਦੀ ਯਾਤਰਾ ਵਿੱਚ ਸੁਰੱਖਿਆ, ਅਨੁਸ਼ਾਸਨ, ਪਾਰਦਰਸ਼ਤਾ ਅਤੇ ਭਰੋਸੇ ਨੂੰ ਯਕੀਨੀ ਬਣਾਉਣ ਵਾਲਾ ਇੱਕ ਜੁੜਿਆ ਹੋਇਆ ਲਿਵਿੰਗ ਇਕੋਸਿਸਟਮ।",

    applauseSub: "Give, receive, and track meaningful applause",
  },
  as: {
    owner: "মালিক",
    manager: "ব্যৱস্থাপক",
    student: "ছাত্র",
    parent: "অভিভাৱক",
    mess: "মেছ",
    activities: "কাৰ্যকলাপ",
    ranking: "ৰেংকিং",
    notifications: "অধিসূচনা",
    admin: "প্ৰশাসক",
    dashboard: "ডেশ্ববোর্ড",
    hpi: "হোষ্টেল পাৰফৰ্মেন্স সূচক (HPI)",
    totalPoints: "মুঠ পইণ্ট",
    studentRanking: "ছাত্র ৰেংকিং",
    yourChild: "আপোনাৰ সন্তান",
    institutionAdmin: "সংস্থা প্ৰশাসক",
    quickAccess: "দ্ৰুত ছাত্র প্ৰৱেশ",
    occupancy: "অধিভোগ",
    revenue: "ৰাজস্ব",
    profitIndex: "লাভ সূচক",
    activeHostels: "সক্ৰিয় হোষ্টেল",
    occupied: "পূৰ্ণ",
    vacant: "খালী",
    hostels: "হোষ্টেল",
    hostelList: "হোষ্টেল তালিকা",
    students: "ছাত্র",
    studentDetails: "ছাত্রৰ বিৱৰণ",
    messages: "বাৰ্তা",
    messMenu: "মেছ মেনু",
    rankings: "ৰেংকিং",
    contacts: "যোগাযোগ",
    photos: "ফটো",
    reply: "উত্তৰ দিয়ক",
    priority: "অগ্ৰাধিকাৰ",
    attendance: "উপস্থিতি",
    foodChoice: "খাদ্য পছন্দ",
    warden: "ৱাৰ্ডেন",
    seats: "আসন",
    rca: "কাৰণমূলক মূল কাৰণ বিশ্লেষণ",
    books: "ইমাৰ্চিভ কিতাপ",
    myBooks: "মোৰ কিতাপ",
    pocketMoney: "পকেট ধন",
    ai: "এআই",
    peer: "সহপাঠী",
    tasks: "কাৰ্য",
    routine: "দৈনিক ৰুটিন",
    overview: "সাৰাংশ",
    billing: "বিলিং",
    policy: "নীতি",
    analytics: "বিশ্লেষণ",
    institution: "সংস্থা",
    alerts: "সতৰ্কতা",
    selfAttendance: "স্ব-উপস্থিতি",
    compulsoryAttendance: "বাধ্যতামূলক উপস্থিতি",
    messAttendance: "মেছ উপস্থিতি",
    activityAttendance: "কাৰ্যকলাপ উপস্থিতি",

    menu: "মেনু",
    transporter: "পৰিবহনকাৰী",
    schedule: "সময়সূচী",
    roles: "ভূমিকা",
    features: "বৈশিষ্ট্য",
    audit: "অডিট",
    settings: "ছেটিংছ",
    signal: "এআই সংকেত",
    emergency: "জৰুৰীকালীন",
    pg: "পি.জি.",
    dormitory: "ডৰ্মিটৰী",
    huma: "HUMA",
    outreach: "আউটৰিচ",
    contactPlatform: "টেক টিমৰ সৈতে যোগাযোগ কৰক",
    shareAttendance: "উপস্থিতি ভাগ কৰক",
    share: "ভাগ কৰক",
    downloadPDF: "ডাউনলোড",
    print: "প্ৰিণ্ট",

    attendanceReports: "উপস্থিতি প্ৰতিবেদন",
    dbDirector: "ডিজিডাইৰেক্টৰ",
    applause: "তালি",
    transit: "ট্ৰানজিট",
    hRoutine: "হোষ্টেল ৰুটিন",
    pSpace: "ব্যক্তিগত স্থান",
    dosdont: "কৰিবলগীয়া আৰু নকৰিবলগীয়া",
    aiDashboard: "এআই ডেশ্ববোর্ড",
    myDiary: "মোৰ ডায়েৰী",
    trustee: "ট্ৰাষ্টী",
    onboarding: "অনবোর্ডিং",
    coordinator: "সমন্বয়ক",
    records: "ৰেকৰ্ড",
    hideattendcapt: "উপস্থিতি কেপচাৰ লুকুৱাওক",
    showattendcapt: "উপস্থিতি কেপচাৰ দেখুৱাওক",
    main_gate: "মূল গেট",
    room: "কোঠা",
    indoor_activity: "ঘৰৰ ভিতৰৰ কাৰ্যকলাপ",
    outdoor_activity: "বাহিৰৰ কাৰ্যকলাপ",
    offsite: "অফছাইট",
    hafhprofile: "প্ৰফাইল",

    hafhAbout: "আমাৰ বিষয়ে",
    hafhUpdates: "আপডেটসমূহ",
    hafh: "হোম অৱে ফ্ৰম হোম",
    subTitle: "প্ৰতিটো ছাত্ৰৰ যাত্ৰাত সুৰক্ষা, শৃঙ্খলা, স্বচ্ছতা আৰু বিশ্বাস নিশ্চিত কৰা এটা সংযুক্ত লিভিং ইক’চিষ্টেম।",

    applauseSub: "Give, receive, and track meaningful applause",
  },
};

export default HAFHTranslations;